<template>
  <div class="setSubmitCate">
    <select name="" id="" v-model="codeValue" class="input">
      <option value="">{{locale.admin_codelist}}</option>
      <option v-for="code in codeList" :key="code.id" :value="code.id">{{code.label}}</option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SetSubmitCate',
  props: [
    'submitData'
  ],
  computed: {
    ...mapGetters({
      getCode: 'admin/submitCodeList'
    }),
    locale () {
      return this.$store.state.service.locale.data
    },
    codeList () {
      const list = this.getCode.filter(x => x.id !== 'system_amenity')
      return list
    },
    codeValue: {
      get () {
        return this.submitData
          ? typeof (this.codeList.find(x => x.id === this.submitData.submitTo)) === 'undefined'
            ? ''
            : this.submitData.submitTo
          : ''
      },
      set (val) {
        const data = this.codeList.find(x => x.id === val)
        this.$store.dispatch('page/setSubmitTo', data)
      }
    }
  },
  created () {
    this.$store.dispatch('admin/getCodes')
  }
}
</script>
